import { render, staticRenderFns } from "./altaUsuarios.vue?vue&type=template&id=77c387b4&"
import script from "./altaUsuarios.vue?vue&type=script&lang=js&"
export * from "./altaUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports